<template>
  <a-modal
    @cancel="handleClose"
    top="40%"
    width="380px"
    :visible="visible"
    title="验证银行卡信息"
    :footer="false"
  >
    <div class="content_">
      <p class="title_">已向您的绑定手机{{ phone }}发送短信验证码</p>
      <div>
        <label v-for="item in codes" class="code_">
          {{ item }}
        </label>
      </div>
      <p
        @click="handleRetrySmsCode"
        :class="count < 1 ? 'active_' : ''"
        class="desc_"
      >
        重新发送 <label v-if="count > 0">{{ count }}s</label>
      </p>
      <div>
        <a-button @click="handleSubmit" class="btn_" type="primary"
          >确认支付</a-button
        >
      </div>
    </div>
  </a-modal>
</template>
<style lang="scss" scoped>
.content_ {
  margin: 0 auto;
  text-align: center;
}
.title_ {
  margin-bottom: 10px;
  font-size: 14px;
  font-family: MicrosoftYaHeiUI;
  color: #999999;
}
.desc_ {
  font-size: 14px;
  font-family: MicrosoftYaHeiUI;
  color: #999999;
  margin: 29px 0 14px;
}
.active_ {
  color: #2c5acc;
}
.code_ {
  display: inline-block;
  vertical-align: top;
  width: 35px;
  height: 48px;
  line-height: 48px;
  border-radius: 2px;
  border: 1px solid #e7e7e7;
  margin-right: 15px;
  font-size: 24px;
  font-family: MicrosoftYaHeiUI-Bold, MicrosoftYaHeiUI;
  font-weight: bold;
  color: #2c5acc;

  &:last-child {
    margin-right: 0;
  }
}
.btn_ {
  width: 284px;
}
</style>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    mobile: {
      type: String,
      default: ""
    }
  },
  computed: {
    phone() {
      return this.mobile.replace(/(\d{3})(\d{4})(\d{4})/, function(
        $1,
        $2,
        $3,
        $4
      ) {
        return $2 + "****" + $4;
      });
    }
  },
  data() {
    return {
      codes: new Array(6),
      count: 0
    };
  },
  mounted() {
    let i = 0;
    this.codes = new Array(6);
    window.onkeyup = e => {
      console.log(e, "e -> ");
      if (e.key && e.key.toLowerCase() == "backspace" && i > -1) {
        this.codes[--i] = "";
      } else if (this.codes.length > i && e.key) {
        this.codes[i++] = e.key;
      }
      this.codes = [...this.codes];
    };
    this.startCountDown();
  },
  beforeDestroy() {
    window.onkeyup = null;
  },
  methods: {
    handleRetrySmsCode() {
      if (this.count > 0) {
        return;
      }
      this.$emit("reGetPayCode");
      this.startCountDown();
    },
    handleClose() {
      this.$emit("cancel");
    },
    handleSubmit() {
      this.$emit("ok", this.codes.join(""));
    },
    startCountDown() {
      this.count = 59;
      let si = setInterval(() => {
        this.count--;
        if (this.count < 1) {
          clearInterval(si);
        }
      }, 1000);
    }
  }
};
</script>
